module.exports = __webpack_public_path__ + "img/zfb.eba80b0a.png";